import ReactPlayer from "react-player";
import { all_routes } from "../router/all_routes";
import { useNavigate } from "react-router";
import {
  FaRegArrowAltCircleLeft,
  FaRegArrowAltCircleRight,
} from "react-icons/fa";

// const VideoViewer: React.FC<{ id: String, videoUrl: string }> = ({
const VideoViewer = () => {
  const routes = all_routes;
  const navigate = useNavigate();

  const handlePageChange = (newPage) => {
    // if (newPage >= 1 && newPage <= numPages) {
    //   setPageNumber(newPage);
    // }
  };

  const endSession = () => {
    alert("Session Completed!");
    navigate(routes.training);
    // navigate(routes.selectUnit);
  };

  return (
    <div className="page-wrapper mt-4 px-2 px-md-4">
      <div className="d-flex ">
        <button className="complete-session-btn ms-auto" onClick={endSession}>
          Complete Session
        </button>
      </div>

      {/* <input type="file" accept="application/pdf" onChange={onFileChange} /> */}

      <div className="video-wrapper rounded-1 mt-3 position-relative">
        <ReactPlayer
          src="https://www.youtube.com/watch?v=VTLCoHnyACE&ab_channel=ApnaCollege"
          height={"60vh"}
          width={"100%"}
          autoPlay={true}
          controls={true}
          className="rounded-2"
        />

        <div className="">
          <FaRegArrowAltCircleLeft
            className="nav-arrow left-arrow "
            size={44}
            // onClick={() => handlePageChange()}
            style={
              {
                // pointerEvents: pageNumber <= 1 ? "none" : "auto",
                //   opacity: pageNumber <= 1 ? 0.4 : 1,
              }
            }
          />

          <FaRegArrowAltCircleRight
            className="nav-arrow right-arrow"
            size={44}
            // onClick={() => handlePageChange()}
            style={
              {
                // pointerEvents: pageNumber >= numPages ? "none" : "auto",
                //   opacity: pageNumber >= numPages ? 0.4 : 1,
              }
            }
          />
        </div>
      </div>
    </div>
  );
};

export default VideoViewer;
